<template>
<v-container fluid grid-list-md style="padding: 30px;">
  <!--<v-data-table :search="search" v-if="!addUser" :headers="headers" :items="eventos" sort-desc class="elevation-1" style="border-radius: 10px;">
    <template v-slot:top>
      <v-toolbar flat color="white" style="border-radius: 10px;">
        <v-toolbar-title class="textoUser">EVENTOS
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <form ref="myform" action="confirmarPagamento" method="POST"></form>
        <v-btn text @click="dialogInicialReplicar" tile color="#4A148C">
          <v-icon left dark>add_circle</v-icon> Adicionar novo
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon @click="editItem(item)">
        edit
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="#7B1FA2" @click="carregaDados">Recarregar</v-btn>
    </template>
  </v-data-table>-->

  <!-- CARD INSERE EVENTOS -->

  <v-card style="border-radius: 10px;">

    <template>
      <v-card-title>
        <span class="textoUser">{{ formTitle }}</span>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <div style="text-align: center"><b>Selecione o(s) dia(s)</b></div>
          <br>
          <v-date-picker
            v-model="datas"
            multiple
            full-width
            locale="pt-br"
            color="#7B1FA2"
          ></v-date-picker>
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <div style="text-align: center"><b>Horários Disponíveis</b></div>
          <br>
          <div
            v-for="item in this.horasDisponiveis"
            :key="item.hora"
            style="display: inline-block">
            <v-chip
              v-if="item.chip"
              class="ma-2"
              close
              color="#7B1FA2"
              outlined
              @click:close="item.chip = false"
            >
              {{item.hora}}
            </v-chip>
          </div>
        </v-col>
      </v-row>

      <!--<v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.descricao" outlined label="Descrição" color="#7B1FA2"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.vagas" outlined label="Vagas" color="#7B1FA2"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.reserva" outlined label="Reservas" color="#7B1FA2"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.inicio" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Início" color="#7B1FA2"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.fim" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Fim" color="#7B1FA2"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>-->

      <v-card-actions>
        <v-flex>
        <v-spacer></v-spacer>
        <v-btn color="#4A148C" class="cssBotao" dark @click="salvarAgenda">Salvar</v-btn>
        <v-btn color="#BA68C8" max-width="" class="cssBotao" dark @click="close">Cancelar</v-btn>
        </v-flex>
      </v-card-actions>
    </template>

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card light>
        <v-container>
          <v-layout wrap>
            <v-flex xs12 sm12 md12 v-if="true">
              <br>
              <v-autocomplete light v-model="tipoSelecionado" :items="eventosCadastrados" item-value="id" item-text="nome" label="Escolha um Evento"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-checkbox v-model="checkbox1" :label="`Incluir inscritos`" style="float: left; margin-right: 30px"></v-checkbox>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="avancarReplicar()">Avançar</v-btn>
          <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>

  <v-dialog v-model="dialogReplicarEvento" max-width="500px" persistent>
    <v-card light>
      <v-container>
        <h4 style=" text-align: center">Deseja replicar algum evento?</h4>
        <v-flex xs12 sm12 lg3>
          <template>
            <div>
            </div>
          </template>
        </v-flex>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#4A148C" ref="confirmar" class="cssBotao" dark large @click.native="replicarSim()">Sim</v-btn>
        <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click.native="replicarNao()">Não</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

  <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>

  <Snackbar ref=chamaSnackbar />

</v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  baseApiUrl
} from '@/global'
import moment from 'moment'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import {
  mapState
} from 'vuex'
export default {
  components: {
    Snackbar,
    Loading
  },
  data: () => ({
    empresa: null,
    datas: [],
    horasDisponiveis: [],
    chip3: true,
    menu: false,
    fullPage: true,
    isLoading: false,
    limitado: true,
    faixas: [],
    search: '',
    addUser: false,
    dialog: false,
    dialogReplicarEvento: false,
    adicionarEvento: false,
    checkbox1: false,
    eventosCadastrados: [],
    tipoSelecionado: '',
    id_evento: '',
    temInscritos: false,
    headers: [{
        text: 'Nome',
        align: 'start',
        value: 'nome',
      },
      {
        text: 'Descrição',
        value: 'descricao'
      },
      {
        text: 'Vagas',
        align: 'center',
        value: 'vagas'
      },
      {
        text: 'Reservas',
        align: 'center',
        value: 'reserva'
      },
      {
        text: 'Data Início',
        value: 'inicio'
      },
      {
        text: 'Data Fim',
        value: 'fim'
      },
      {
        text: 'Ações',
        value: 'action',
        align: 'center',
        sortable: false
      },
    ],
    eventos: [],
    editedIndex: -1,
    agenda: {
      nome: '',
      descricao: '',
      empresaId: '',
      datas: [],
    },
    inscricoesItem: [{
      cod_incricao: '',
      nome: '',
      cpf: '',
      sexo: '',
      telefone: '',
      tipo: '',
      eventoId: '',
      checkin: '',
      checkout: '',
    }],
    defaultItem: {
      nome: '',
      descricao: '',
      vagas: '',
      reserva: '',
      inicio: '',
      fim: '',
      empresaId: '',
    },
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'AGENDA ' : 'EDITAR AGENDA'
    }
  }),

  created() {

  },

  mounted() {

    this.carregaDados()

    /* var foo = document.createElement('script');    
    foo.setAttribute("src","https://www.mercadopago.com.br/integrations/v1/web-payment-checkout.js");
    foo.setAttribute("data-preference-id","80474295-1f12a4d8-ecc0-4c15-b5b9-44c2ae319ff0")      
    this.$refs.myform.appendChild(foo);

   */

  },

  watch: {
    dialogReplicarEvento() {
      if (!this.dialogReplicarEvento) return
      requestAnimationFrame(() => {
        this.$refs.confirmar.$el.focus()
      })
      this.checkbox1 = false
    }
  },

  methods: {
    async avancarReplicar() {
      var vm = this
      this.temInscritos = false
      try {
        let res = await axios.get(`${baseApiUrl}Eventos?filter[where][id]=${this.tipoSelecionado}&access_token=${sessionStorage.getItem('accToken')}`)

        if (this.tipoSelecionado != '') {
          let dataInicio = res.data[0].inicio.split('-')
          let dataFim = res.data[0].fim.split('-')

          this.editedItem.nome = res.data[0].nome
          this.editedItem.descricao = res.data[0].descricao
          this.editedItem.vagas = res.data[0].vagas
          this.editedItem.reserva = res.data[0].reserva
          this.editedItem.inicio = dataInicio[2].substring(0, 2) + dataInicio[1] + dataInicio[0]
          this.editedItem.fim = dataFim[2].substring(0, 2) + dataFim[1] + dataFim[0]

          if (this.checkbox1 == true) {

            try {
              let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"eventoId": +"${this.tipoSelecionado}"}}&access_token=${sessionStorage.getItem('accToken')}`)

              if (res.data != '') {
                this.inscricoesItem = res.data

                this.dialogReplicarEvento = false
                this.adicionarEvento = true
                this.temInscritos = true

              } else {
                vm.$refs.chamaSnackbar.snack("error", "Não foram encontrados inscritos para este evento.")
              }

            } catch (error) {
              vm.$refs.chamaSnackbar.snack("error", "Erro ao buscar inscritos para este evento.")
            }
          } else {
            this.dialogReplicarEvento = false
            this.adicionarEvento = true
          }

        }

      } catch (error) {
        vm.$refs.chamaSnackbar.snack("error", "Erro ao consultar eventos.")
      }

    },

    async replicarSim() {
      this.tipoSelecionado = '';
      this.adicionarEvento = false;
      this.dialog = true;
    },

    async replicarNao() {
      this.dialogReplicarEvento = false;
      this.adicionarEvento = true;
    },

    async dialogInicialReplicar() {
      this.adicionarEvento = false;
      this.dialog = false;
      this.dialogReplicarEvento = true;
      this.verificaDisponibilidade();
    },

    async carregaDados() {
      this.isLoading = true
      await axios.get(`${baseApiUrl}Eventos?filter[where][empresaId]=${this.companyobj.id}&access_token=${sessionStorage.getItem('accToken')}`)
        .then(res => {
          if (res.data != '') {
            this.eventos = []
            //this.eventos = res.data
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                /* if(this.formatDate(res.data[key].inicio.substr(0, 10)) >= this.formatDateBrz(new Date().toISOString().substr(0, 10)))
                  { */
                this.eventos.push({
                  'nome': res.data[key].nome,
                  'descricao': res.data[key].descricao,
                  'vagas': res.data[key].vagas,
                  'reserva': res.data[key].reserva,
                  'inicio': this.formatDate(res.data[key].inicio.substr(0, 10)) + " " + res.data[key].inicio.substr(11, 8),
                  'fim': this.formatDate(res.data[key].fim.substr(0, 10)) + " " + res.data[key].fim.substr(11, 8),
                  'empresaId': res.data[key].empresaId,
                  'id': res.data[key].id
                });
                /*  } */
              }
            }
            this.eventos = this.eventos.sort(this.compare)

            if (res.data != null) {
              this.eventosCadastrados = res.data
              this.empresa = JSON.parse(sessionStorage.getItem("company"))
              let horaAbertura = this.empresa.horaAbertura.split(":")
              let horaFechamento = this.empresa.horaFechamento.split(":")
              let intervaloInicio = this.empresa.intervaloInicio.split(":")
              let intervaloFim = this.empresa.intervaloFim.split(":")
              this.horasDisponiveis = []
              for (let i = parseInt(horaAbertura[0]); i < parseInt(intervaloInicio[0]); i++) {
                this.horasDisponiveis.push({
                  hora: i.toString() + ":" + horaAbertura[1],
                  chip: true
                })
              }
              for (let i = parseInt(intervaloFim[0]); i < parseInt(horaFechamento[0]); i++) {
                  this.horasDisponiveis.push({
                    hora: i.toString() + ":" + horaAbertura[1],
                    chip: true
                  })
                }
              }
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        })
    },

    compare(a) {
      // Use toUpperCase() to ignore character casing
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
      //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
      const dataC = moment().format()

      let comparison = 0;
      if (dataC >= dataA) {
        comparison = 1;
      } else if (dataC < dataA) {
        comparison = -1;
      }
      return comparison;

    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    openDialog() {
      this.dialog = true
    },

    editItem(item) {
      this.editedIndex = this.eventos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.adicionarEvento = true
      this.addUser = true
    },

    async deleteItem(item) {
      var r = confirm('Deseja realmente excluir o Evento: ' + item.nome + '?')
      if (r == true) {
        await axios.delete(`${baseApiUrl}Eventos/${item.id}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          })
      }
    },

    close() {
      this.dialogReplicarEvento = false
      this.addUser = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async salvarAgenda() {
      this.isLoading = true
      this.agenda.empresaId = this.empresa.id
      for (let i = 0; i < this.datas.length; i++) {
        for (let j = 0; j < this.horasDisponiveis.length; j++) {
          if (this.horasDisponiveis[j].chip){
              this.agenda.datas.push({
              data: this.datas[i],
              hora: this.horasDisponiveis[j].hora,
              vagas: 1,
              reserva: 0,
            })
          }
        }
      }
      await axios.post(`${baseApiUrl}Eventos/programaAgenda`, this.agenda)
          .then(res => {
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaDados()
            }
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
    },

    async verificaDisponibilidade() {
      var creditoFaixa = []
      this.faixas = []
      await axios.get(`${baseApiUrl}Empresas?filter[where][id]=${this.companyobj.id}&access_token=${this.token}`)
        .then(res => {
          creditoFaixa = res.data[0].creditoFaixa
        })
      if (creditoFaixa.faixa1 != 0) {
        this.limitado = true
        this.faixas.push(30)
        this.addUser = true
      }
      if (creditoFaixa.faixa2 != 0) {
        this.limitado = true
        this.faixas.push(60)
        this.addUser = true
      }
      if (creditoFaixa.faixa3 != 0) {
        this.limitado = true
        this.faixas.push(100)
        this.addUser = true
      }
      if (creditoFaixa.faixa4 != 0) {
        this.limitado = false
        this.addUser = true
      }
      if (creditoFaixa.faixa1 == 0 && creditoFaixa.faixa2 == 0 && creditoFaixa.faixa3 == 0 && creditoFaixa.faixa4 == 0) {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Você não possui créditos para a inclusão de um novo evento, entre em contato com a Intelite e solicite agora!", "ATENÇÃO")
      }

    }
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url('https://fonts.google.com/specimen/Roboto');
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 50px;
  font-size: 7px;
  margin: 10px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
